import React from "react";
import {
    useJWT,
} from './JWT';
import {
    useParams
} from "react-router-dom";
import {
    BiLoaderCircle
} from "react-icons/bi";
import Alert from 'react-bootstrap/Alert';

export function BotHome() {
    const jwt = useJWT();
    const { namespace, handle } = useParams();
    const [error, setError] = React.useState("");
    const [loading, setLoading] = React.useState(true);
    const [bot, setBot] = React.useState({});

    async function loadBot(jwt, namespace, handle) {
        fetch(`https://api.${process.env.REACT_APP_DOMAIN}/rest/bots/${namespace}/${handle}`, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + jwt.token
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`${response.status} ${response.statusText}`);
            }
            return response.json()
        }).then(payload => {
            setBot(payload.bot);
            setError(false);
            setLoading(false);
        }).catch(error => {
            console.error("loading bot: ", error);
            setBot({});
            setError(error);
            setLoading(false);
        })
    }

    React.useEffect(() => {
        loadBot(jwt, namespace, handle);
    }, [jwt, namespace, handle]);

    if (loading) {
        return (
            <><BiLoaderCircle/></>
        );
    }
    if (error) {
        return (
            <Alert variant="danger">
              {error.message}
            </Alert>
        );
    }
    return (
        <>
          namespace: {bot.namespace}<br/>
          handle: {bot.handle}<br/>
          repository: registry.{process.env.REACT_APP_DOMAIN}/{bot.namespace}/{bot.handle}<br/>
          digest of <code>:latest</code> image: {bot.image_digest}<br/>
          digest of deployed image: {bot.deployment_digest}<br/><br/>

          <p>
            login to the docker registry:<br/><br/>
            <code>
            docker login --username "{jwt.claims.sub}" registry.{process.env.REACT_APP_DOMAIN}
            </code><br/><br/>
            ... you'll be prompted for your {process.env.REACT_APP_DOMAIN} password.
          </p><br/>

          <p>
            tag and push your bot as a docker image:<br/><br/>
            <code>
            docker tag YOUR_BOT_IMAGE registry.{process.env.REACT_APP_DOMAIN}/{bot.namespace}/{bot.handle}:latest<br/>
            docker push registry.{process.env.REACT_APP_DOMAIN}/{bot.namespace}/{bot.handle}:latest
            </code><br/><br/>
            ... within a few moments, the most recent <code>:latest</code> image gets deployed... and that's it!
          </p>
        </>
    );
}

export default BotHome;
